import { initFilters } from 'actions/search';

export function appBoot() {
  return (dispatch, getState) => {
    dispatch(initFilters());
  };
}



// WEBPACK FOOTER //
// ./src/actions/lifecycle.js